export enum EServiceupdateState {
  UNPUBLISHED = 'UNPUBLISHED', PUBLISHED = 'PUBLISHED', CANCELED = 'CANCELED'
}
